//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_UNALLOACTED_BALANCE =
  'GET_REBATE_PROGRAM_UNALLOACTED_BALANCE';
export const GET_ERROR_MSG_QUARTERLY_PAYMENT =
  'GET_ERROR_MSG_QUARTERLY_PAYMENT';
export const SET_MANUFACTURERS_LIST_UNALLOACTED_BALANCE =
  'SET_MANUFACTURERS_LIST_UNALLOACTED_BALANCE';
export const GET_UNALLOCATED_BALANCE_REPORT = 'GET_UNALLOCATED_BALANCE_REPORT';
export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_UNALLOCATED = 'REFRESH_UNALLOCATED';
export const REFRESH_UNALLOCATED_DETAIL = 'REFRESH_UNALLOCATED_DETAIL';
export const SET_PAGINATION_INDEX_UNALLOCATED =
  'SET_PAGINATION_INDEX_UNALLOCATED';
